module.exports = __webpack_public_path__ + "static/media/Pradum_Kumar_Resume_ML.718aa88b.pdf";